import { useEffect, useState } from 'react';
import { CHART_ANIMATION_CONFIG, DatavizColor, ProgressChart } from '@mews/b2b-ui';

const animationDelay = CHART_ANIMATION_CONFIG.animationDuration + CHART_ANIMATION_CONFIG.animationBegin;

interface LimitsProgressChartProps {
    color: DatavizColor;
    total: number;
    value: number;
}

export const LimitsProgressChart = ({ color, total, value }: LimitsProgressChartProps) => {
    const [hasAnimationEnabled, setAnimated] = useState(true);

    useEffect(() => {
        let timeoutId: number | undefined;

        if (hasAnimationEnabled) {
            timeoutId = window.setTimeout(() => setAnimated(false), animationDelay);
        }

        return () => {
            if (!timeoutId) return;

            window.clearTimeout(timeoutId);
        };
    }, [hasAnimationEnabled, setAnimated]);

    return (
        <ProgressChart
            animated={hasAnimationEnabled}
            total={total}
            data={[
                {
                    id: 'dailyLimit',
                    name: 'dailyLimit',
                    value,
                    color,
                },
            ]}
        />
    );
};
